import { useState, useCallback, useEffect } from 'react';

const STORAGE_PREFIX = 'whoseland_onboarding_dismissed_';

export default function useOnboardingDismissal(projectsid) {
  const key = projectsid ? `${STORAGE_PREFIX}${projectsid}` : '';

  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    if (!key) {
      setIsDismissed(false);
      return;
    }
    try {
      setIsDismissed(localStorage.getItem(key) === 'true');
    } catch {
      setIsDismissed(false);
    }
  }, [key]);

  const dismiss = useCallback(() => {
    if (!key) return;
    try {
      localStorage.setItem(key, 'true');
    } catch { /* localStorage unavailable */ }
    setIsDismissed(true);
  }, [key]);

  const reset = useCallback(() => {
    if (!key) return;
    try {
      localStorage.removeItem(key);
    } catch { /* localStorage unavailable */ }
    setIsDismissed(false);
  }, [key]);

  return { isDismissed, dismiss, reset };
}
